module.exports = __webpack_public_path__ + "static/media/wemystic.e32e64d6.webp";